import axios from 'axios';
import axiosRetry from 'axios-retry';
import toastr from 'toastr';
import * as actions from './actionsTypes';
import errorManage from '../errorManage';
import messages from '../../redux/messages';
import instituteServices from './institute.services';

const client = axios.create({ baseURL: process.env.REACT_APP_URL });
axiosRetry(client, { retries: 5, retryDelay: axiosRetry.exponentialDelay });

export const getInstitute = (params, iType) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_INSTITUTE,
      payload: true
    });
    // const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};

    // const resp = await client.get(iType === 1 ? '/api/app/Formal_Instituto/' : '/api/app/Funcional_Instituto/', {
    //   headers: {
    //     'Content-Type': 'application/json',
    //     'Authorization': `Token ${token}`
    //   },
    //   params: data
    // });
    const resp = await instituteServices.getInstitutes(params, iType);
    dispatch({
      type: actions.GET_INSTITUTE,
      payload: {
        institute: resp.data.data,
        instituteLength: resp.data.count
      }
    });
    dispatch({
      type: actions.INSTITUTE_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
        message = ex.response.data.mensaje;
      }else{
        errorManage(ex);
        message = messages.errorMessage;
      }
    }else{
      errorManage(ex);
      message = messages.errorMessage;
    }
    dispatch({
      type: actions.INSTITUTE_FAIL,
      payload: message,
    });
  }finally{
    dispatch({
      type: actions.LOADING_INSTITUTE,
      payload: false
    });
  }
}

export const saveInstitute = (req, iType, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_INSTITUTE,
      payload: true
    });

    // const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    // const resp = await client.post(iType === 1 ? '/api/app/Formal_Instituto/' : '/api/app/Funcional_Instituto/', data, {
    //   headers: {
    //     'Content-Type': 'application/json',
    //     'Authorization': `Token ${token}`
    //   }});
    const resp = await instituteServices.saveInstitute(req, iType);
    const { institute, instituteLength } = getState().institute;
    const aInstitute = [...institute, resp.data];
    dispatch({
      type: actions.GET_INSTITUTE,
      payload: {
        institute: aInstitute,
        instituteLength: instituteLength + 1
      }
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    let message = null;
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
        message = ex.response.data.mensaje;
      }else{
        errorManage(ex);
        message = messages.errorMessage;
      }
    }else{
      errorManage(ex);
      message = messages.errorMessage;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  }finally{
    setShowModal(false)
    dispatch({
      type: actions.SAVE_LOADER_INSTITUTE,
      payload: false
    });
  }
}

export const editInstitute = (req, id, index, iType, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_INSTITUTE,
      payload: true
    });

    // const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    // const resp = await client.put(iType === 1 ? `/api/app/Formal_Instituto/${id}/` : `/api/app/Funcional_Instituto/${id}/`, data, {
    // headers: {
    //   'Content-Type': 'application/json',
    //   'Authorization': `Token ${token}`
    // }});
    const resp = await instituteServices.editInstitute(id, req, iType);
    const { institute, instituteLength } = getState().institute;
    institute[index] = resp.data;
    //const aJobPositions = [...jobPositions, resp.data];
    dispatch({
      type: actions.GET_INSTITUTE,
      payload: {
        institute: institute,
        instituteLength: instituteLength
      }
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    let message = null;
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
        message = ex.response.data.mensaje;
      }else{
        errorManage(ex);
        message = messages.errorMessage;
      }
    }else{
      errorManage(ex);
      message = messages.errorMessage;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  }finally{
    setShowModal(false)
    dispatch({
      type: actions.SAVE_LOADER_INSTITUTE,
      payload: false
    });
  }
}

export const deleteInstitute = (id, index, iType) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_INSTITUTE,
      payload: true
    });

    // const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    // await client.delete(iType === 1 ? `/api/app/Formal_Instituto/${id}/` : `/api/app/Funcional_Instituto/${id}/`, {
    // headers: {
    //   'Content-Type': 'application/json',
    //   'Authorization': `Token ${token}`
    // }});
    await instituteServices.deleteInstitute(id, iType);
    const { institute, instituteLength } = getState().institute;
    institute.splice(index, 1);
    //const aJobPositions = [...jobPositions, resp.data];
    dispatch({
      type: actions.GET_INSTITUTE,
      payload: {
        institute: institute,
        instituteLength: instituteLength -1
      }
    });
    dispatch({
      type: actions.INSTITUTE_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    let message = null;
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
        message = ex.response.data.mensaje;
      }else{
        errorManage(ex);
        message = messages.errorMessage;
      }
    }else{
      errorManage(ex);
      message = messages.errorMessage;
    }
    dispatch({
      type: actions.INSTITUTE_FAIL,
      payload: message,
    });
  }finally{
    dispatch({
      type: actions.LOADING_INSTITUTE,
      payload: false
    });
  }
}
